import { CUSTOMER_CONFIG } from "../../../common/constants";
import DeliveryExceptionSaia from "./ExceptionDetailSaia";
import DeliveryExceptionDefault from "./ExceptionDetailDefault";
import { withAppConfig } from "../../../../../../../../appConfigContext";
import * as SAIAException from "./ExceptionDetailSaia/utils";
import * as DefaultException from "./ExceptionDetailDefault/utils";
import { ExceptionDetailsDefault } from "./ExceptionDetailDefault/Details";
import { ExceptionDetailsSaia } from "./ExceptionDetailSaia/Details";

const getExceptionDetailsFunction = (exceptionFlow) => {
  if (exceptionFlow === CUSTOMER_CONFIG.SAIA) {
    return {
      ExceptionDetailsForm: DeliveryExceptionSaia,
      ExceptionDetailsInfo: ExceptionDetailsSaia,
      ...SAIAException,
    };
  }
  return {
    ExceptionDetailsForm: DeliveryExceptionDefault,
    ExceptionDetailsInfo: ExceptionDetailsDefault,
    ...DefaultException,
  };
};

export function withExceptionDetailsHOC(Component) {
  return withAppConfig((props) => {
    const deliveryException = getExceptionDetailsFunction(
      props.configJSON?.exceptionFlow
    );
    return <Component {...props} deliveryException={deliveryException} />;
  });
}
